import { ApiFunc, getInstance } from '@helpers/httpClient'

import * as API from '../constants/api'

export const dashboardStudent: ApiFunc<`${typeof API.DASHBOARD_STUDENT}`, 'get'> = data =>
  getInstance().get(API.DASHBOARD_STUDENT, {
    params: data,
  })

export const dashboardV2Student: ApiFunc<`${typeof API.DASHBOARD_V2_STUDENT}`, 'get'> = data =>
  getInstance().get(API.DASHBOARD_V2_STUDENT, {
    params: data,
  })
